import React, { useMemo } from 'react';
import cn from "classnames";
import style from "../common.module.scss"
import { ORDER_STATUSES_DATA } from '../../../../mock';
import BallIcon from '../../../shared/icons/BallIcon';
import { useTranslation } from 'react-i18next';

const OrdersSectionItemTableStatus = ({ status, driverName, driverSurname }) => {
  const { t } = useTranslation();

  const setSummary = (status) => {
    switch (status) {
      case 'moderation': return t('statusHints.moderation')
      case 'published': return
      case 'waitstarttrip': return ""
      case 'awaitingpayment': return ""
      case 'waitingforcompletion': return
      case 'inprocess': return
      case 'onthetrip': return
      case 'waitloadingcargo': return
      case 'completed': return 
      case 'rejectedunloadingcargomoderation': return
      case 'unloadingcargomoderation': return
      case 'processunloadingcargo': return t('statusHints.processunloadingcargo')
      case 'processloadingcargo': return t('statusHints.processloadingcargo')
      case 'unloadingcargo': return
      case 'loadingcargo': return
      case 'waitcompletion': return
      case 'canceled': return
      case 'booked': return `${driverSurname} ${driverName}`;
      case 'rejected': return
      case 'confirmed': return
      case 'awaitingOffer': return t('statusHints.awaitingOffer')

      default: return '';
    }
  };

  return (
    <div className={cn(style.table_col)}>
      <div className={cn(style.status_lineTitle)} style={{ color: ORDER_STATUSES_DATA(t)[status]?.color }}>
        <BallIcon fill={ORDER_STATUSES_DATA(t)[status]?.color} />
        {ORDER_STATUSES_DATA(t)[status]?.title || status}
      </div>
      <div className={style.status_summary}>
        {setSummary(status)}
      </div>
    </div>
  );
};

export default OrdersSectionItemTableStatus;
